import { render } from "./ListOrderDeliveriesComponent.vue?vue&type=template&id=a17bd5ce"
import script from "./ListOrderDeliveriesComponent.vue?vue&type=script&lang=js"
export * from "./ListOrderDeliveriesComponent.vue?vue&type=script&lang=js"

import "./ListOrderDeliveriesComponent.vue?vue&type=style&index=0&id=a17bd5ce&lang=css"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/order_deliveries/ListOrderDeliveriesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a17bd5ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a17bd5ce', __exports__)) {
    console.log('reload')
    api.reload('a17bd5ce', __exports__)
  }
  
  module.hot.accept("./ListOrderDeliveriesComponent.vue?vue&type=template&id=a17bd5ce", () => {
    console.log('re-render')
    api.rerender('a17bd5ce', render)
  })

}


export default __exports__